import createRootReducer from '../../reducers/apps/case-json';
import { thunk } from 'redux-thunk';
import logger from 'redux-logger';
import authMiddleware from '../../core/middleware/auth-middleware';
import { applyMiddleware, compose, createStore } from 'redux';

const composeEnhancers =
  (window as any).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const rootReducer = createRootReducer();
const reducer = (state: any, action: any) => {
  if (state && 'router' in state) {
    const { router, ...rest } = state;
    return rootReducer(rest, action);
  }
  return rootReducer(state, action);
};

const middlewares: any[] = [
  authMiddleware,
  thunk,
  !process.env.JEST_WORKER_ID && logger
].filter(Boolean);

const store = createStore(
  reducer, // root reducer without router state
  undefined,
  composeEnhancers(applyMiddleware(...middlewares))
);

//const store = buildStore(rootReducer, {router});

export { store };
